// src/utils/api.ts
import { fetchAuthSession } from "@aws-amplify/auth"; // Use fetchAuthSession from Amplify

export const getAuthHeader = async (forceRefresh = false): Promise<{ Authorization?: string }> => {
  try {
    // Force refresh token if requested (useful for expired token scenarios)
    const session = await fetchAuthSession({ forceRefresh });
    const idToken = session.tokens?.idToken?.toString();
    if (idToken) {
      return { Authorization: `Bearer ${idToken}` };  // ✅ Added "Bearer " prefix
    }
    return {};
  } catch (error) {
    console.error("Failed to retrieve auth token", error);
    
    // If normal fetch fails and we haven't tried force refresh, try it
    if (!forceRefresh) {
      console.warn("Retrying with force refresh due to auth failure");
      return getAuthHeader(true);
    }
    
    return {};
  }
};
